import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function Rechner() {
    return (
        <div style={{ minHeight: 'calc(100vh - 70px)', display: 'flex', flexDirection: 'column' }}>
            <div className="container" style={{ paddingTop: '20px', paddingBottom: '12px' }}>
                <Link to="/privat" className="icon-button" style={{ display: 'inline-flex', gap: '8px', alignItems: 'center' }}>
                    <ArrowLeft size={20} />
                    <span style={{ fontWeight: 500 }}>Zurück</span>
                </Link>
            </div>
            <iframe
                src="/tools/rechner.html"
                title="Aufwand & Angebot Rechner"
                style={{ flex: 1, width: '100%', border: 'none', minHeight: '85vh' }}
            />
        </div>
    );
}
